import { Condiciones } from './../../../models/condiciones.model';
import { Component } from "@angular/core";
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { FormService } from 'src/app/services/form.service';

@Component({
    selector: "page-condiciones",
    templateUrl: "./condiciones.component.html",
    styleUrls: ["./condiciones.component.css"],
    providers: [FormService]
})

export class CondicionesComponent {
    public rows = [];
    public actualRow;
    public formulario;
    public condiciones: Condiciones;
    public form;
    public matcher = new FormService();
    public esp
    public form211 = false;

    constructor() {
        if (localStorage.getItem("form")) {
            this.formulario = localStorage.getItem("form");

            if (this.formulario == "2-1.1") {
                this.form211 = true
            }

        }

        this.form = new FormGroup({
            fusion: new FormControl('', Validators.required),
            subdivision: new FormControl('', Validators.required),
            loteo: new FormControl('', Validators.required),
            sub_afecta: new FormControl('', Validators.required),
            est_medidas: new FormControl('', Validators.required),
            rectificacion: new FormControl('', Validators.required),
            modificacion: new FormControl('', Validators.required),
            otros: new FormControl('', Validators.required),
            especificar: new FormControl('', Validators.required),
            solicitud1: new FormControl('', Validators.required),
            fecha1: new FormControl('', Validators.required),
            solicitud2: new FormControl('', Validators.required),
            fecha2: new FormControl('', Validators.required),
            solicitud3: new FormControl('', Validators.required),
            fecha3: new FormControl('', Validators.required)

        })
        if (!JSON.parse(localStorage.getItem("condiciones"))) {
            localStorage.setItem("condiciones", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("condiciones"));
            this.form.controls['fusion'].setValue(this.rows[0] ? this.rows[0].fusion : false);
            this.form.controls['subdivision'].setValue(this.rows[0] ? this.rows[0].subdivision : false);
            this.form.controls['loteo'].setValue(this.rows[0] ? this.rows[0].loteo : false);
            this.form.controls['sub_afecta'].setValue(this.rows[0] ? this.rows[0].sub_afecta : false);
            this.form.controls['est_medidas'].setValue(this.rows[0] ? this.rows[0].est_medidas : false);
            this.form.controls['rectificacion'].setValue(this.rows[0] ? this.rows[0].rectificacion : false);
            this.form.controls['modificacion'].setValue(this.rows[0] ? this.rows[0].modificacion : false);
            this.form.controls['otros'].setValue(this.rows[0] ? this.rows[0].otros : false);
            this.form.controls['especificar'].setValue(this.rows[0] ? this.rows[0].especificar : "");
            this.form.controls['solicitud1'].setValue(this.rows[0] ? this.rows[0].solicitud1 : "");
            this.form.controls['fecha1'].setValue(this.rows[0] ? this.rows[0].fecha1 : "");
            this.form.controls['solicitud2'].setValue(this.rows[0] ? this.rows[0].solicitud2 : "");
            this.form.controls['fecha2'].setValue(this.rows[0] ? this.rows[0].fecha2 : "");
            this.form.controls['solicitud3'].setValue(this.rows[0] ? this.rows[0].solicitud3 : "");
            this.form.controls['fecha3'].setValue(this.rows[0] ? this.rows[0].fecha3 : "");

        }
        this.condiciones = {
            fusion: '',
            subdivision: '',
            loteo: '',
            sub_afecta: '',
            est_medidas: '',
            rectificacion: '',
            modificacion: '',
            otros: '',
            especificar: '',
            solicitud1: '',
            fecha1: '',
            solicitud2: '',
            fecha2: '',
            solicitud3: '',
            fecha3: ''
        };
    }

    add_condiciones() {
        if (this.form.value.otros) {
            this.esp = this.form.value.especificar
        } else {
            this.esp = ""
        }

        localStorage.setItem("condiciones", JSON.stringify([]));
        this.actualRow = localStorage.getItem("condiciones");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            fusion: this.form.value.fusion,
            subdivision: this.form.value.subdivision,
            loteo: this.form.value.loteo,
            sub_afecta: this.form.value.sub_afecta,
            est_medidas: this.form.value.est_medidas,
            rectificacion: this.form.value.rectificacion,
            modificacion: this.form.value.modificacion,
            otros: this.form.value.otros,
            especificar: this.esp,
            solicitud1: this.form.value.solicitud1,
            fecha1: this.form.value.fecha1 ? moment(this.form.value.fecha1).format('DD/MM/YYYY') : "",
            solicitud2: this.form.value.solicitud2,
            fecha2: this.form.value.fecha2 ? moment(this.form.value.fecha2).format('DD/MM/YYYY') : "",
            solicitud3: this.form.value.solicitud3,
            fecha3: this.form.value.fecha3 ? moment(this.form.value.fecha3).format('DD/MM/YYYY') : "",
        })
        localStorage.setItem("condiciones", JSON.stringify(this.rows));
    }

    delete_condiciones(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("condiciones", JSON.stringify(this.rows));
            }
        }
    }

}